'use client'

import MUIStack from '@mui/material/Stack'
import MUITypography from '@mui/material/Typography'

export type StepIndicatorProps = {
  steps: string[]
  currentStepIndex: number
}

// A lightweight, self-contained "N of M" step marker row for the ITSA wizard screens
// (FE5-FE10) — deliberately not coupled to useWizardStore/WizardSidebarTimeline, which
// model a stage+step tree for the general-purpose Osprey wizard shell.
export const StepIndicator = ({ steps, currentStepIndex }: StepIndicatorProps) => {
  return (
    <MUIStack data-testid="StepIndicator" direction="row" gap={2} alignItems="center">
      {steps.map((step, index) => {
        const isCurrent = index === currentStepIndex
        const isComplete = index < currentStepIndex

        return (
          <MUIStack key={step} direction="row" gap={1} alignItems="center">
            <MUIStack
              data-testid={`StepIndicator-marker-${index}`}
              alignItems="center"
              justifyContent="center"
              sx={{
                width: 24,
                height: 24,
                borderRadius: '50%',
                backgroundColor: isCurrent ? 'secondary.main' : isComplete ? 'success.main' : 'background.mid',
                color: isCurrent || isComplete ? 'white' : 'text.secondary',
                fontSize: '0.75rem',
                fontWeight: 600
              }}
            >
              {index + 1}
            </MUIStack>
            <MUITypography
              variant="body2"
              sx={{ color: isCurrent ? 'text.primary' : 'text.secondary', fontWeight: isCurrent ? 600 : 400 }}
            >
              {step}
            </MUITypography>
          </MUIStack>
        )
      })}
    </MUIStack>
  )
}
